import {createContext} from "react";

interface QrCodeContextType {
    open: boolean;
    title: string;
    image: string;
    updateValues: (newOpen: boolean, newTitle: string, newImage: string) => void
}

const QrCodeContext = createContext<QrCodeContextType>({
    open: false, title: '', image: '', updateValues: () => {}
})

export default QrCodeContext;